import { deleteApi, getApi, postApi, putApi } from "./http.service";

export const createNewBeat=async(payload:any)=>{
    return postApi('beats',payload);
}

export const getBeatById=async(id:any)=>{
    return getApi('beats/'+id);
}

export const getAllBeats=async()=>{
    return getApi('beats');
}

export const updateBeatById=async(id:any, payload:any)=>{
    return putApi('beats/'+id, payload);
}

export const deleteBeatById=async(id:any)=>{
    return deleteApi('beats/'+id);
}